import { LeadDialogProvider } from "@/components/site/LeadDialog";
import SmoothScroll from "@/components/story/SmoothScroll";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import CinematicSection from "@/components/cinematic/CinematicSection";
import EditorialMarquee from "@/components/cinematic/EditorialMarquee";
import Services from "@/components/story/Services";
import Process from "@/components/story/Process";
import FinalCTA from "@/components/story/FinalCTA";

export default function Home() {
  return (
    <LeadDialogProvider>
      <SmoothScroll>
        <div className="relative bg-[color:var(--ww-cream)] text-[color:var(--ww-charcoal)] min-h-screen">
          <Header />
          <main>
            <CinematicSection />
            <EditorialMarquee />
            <Services />
            <Process />
            <FinalCTA />
          </main>
          <Footer />
        </div>
      </SmoothScroll>
    </LeadDialogProvider>
  );
}
